<script>
import {
  entityDescriptionComputed,
  entityDescriptionMethods,
  infoDetailsMethods,
} from '@state/helpers'

export default {
  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...entityDescriptionComputed,
  },

  methods: {
    ...infoDetailsMethods,
    ...entityDescriptionMethods,

    entityByNumberAndDeviceType: function(deviceType, number) {
      return this.cachedEntityDescriptions.filter(
        (entityDescription) =>
          entityDescription.deviceTypeId === deviceType &&
          entityDescription.columnId === number
      )
    },
  },
}
</script>

<template>
  <b-card-body
    v-if="deviceEventCurrent"
    class="animated fadeIn card info-card card-body device-card-body-info p-0 pb-3 clearfix"
  >
    <div
      v-if="deviceEventCurrent.cycleCount"
      class="text-uppercase font-weight-bold   p-1 pl-3"
    >
      <p class="mb-0">
        <span class="font-weight-bold  btn-block text-muted float-right">
          CYCLE COUNT
        </span>
        <span>
          {{ deviceEventCurrent.cycleCount }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity1"
      class="text-uppercase font-weight-bold   p-1 pl-3"
    >
      <p class="mb-0">
        <span class="font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 1)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity1 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity2"
      class="text-uppercase font-weight-bold   p-1 pl-3"
    >
      <p class="mb-0">
        <span class="font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 2)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity2 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity3"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 3)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity3 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity4"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 4)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity4 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity5"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 5)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity5 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity6"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 6)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity6 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity7"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 7)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity7 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity8"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 8)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity8 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity9"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 9)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity9 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity10"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 10)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity10 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity11"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 11)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity11 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity12"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 12)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity12 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity13"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 13)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity13 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity14"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 14)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity14 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity15"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 15)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity15 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity16"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 16)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity16 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity17"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 17)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity17 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity18"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 18)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity18 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity19"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 19)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity19 }}
        </span>
      </p>
    </div>
    <div
      v-if="deviceEventCurrent.entity20"
      class="text-uppercase font-weight-bold  p-1 pl-3"
    >
      <p class="mb-0">
        <span class="w-100 font-weight-bold  btn-block text-muted float-right">
          {{ entityByNumberAndDeviceType(deviceEventCurrent.device.typeId, 20)[0].name }}
        </span>
        <span>
          {{ deviceEventCurrent.entity20 }}
        </span>
      </p>
    </div>
  </b-card-body>
</template>

<style lang="scss"></style>
